// import React, { useState, useRef, useEffect } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useLocation, useNavigate } from "react-router-dom";

// function VehicleType() {
//   const formRef = useRef(null);

//   const [formData, setFormData] = useState({
//     VTYPE: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const location = useLocation();
//   // const navigate = useNavigate();

//   useEffect(() => {
//     if (location.state?.responseData) {
//       setFormData({
//         VTYPE: location.state.responseData.VTYPE || "",
//         ID: location.state.responseData.ID || "", // store ID for update
//       });
//     }
//   }, [location]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const proxyUrl = "https://thingproxy.freeboard.io/fetch/";
//     const apiUrl = "http://etour.responseinfoway.com/restapi/insertdata.aspx";

//     const data = new FormData();
//     data.append("SecurityKey", "abcd");
//     data.append("TableName", "VehicleTypes");
//     // data.append("ID", "");
//     data.append("VTYPE", formData.VTYPE);

//     try {
//       const response = await fetch(proxyUrl + apiUrl, {
//         method: "POST",
//         body: data,
//       });

//       const result = await response.json();
//       console.log("API Response:", result);

//       const responseItem = Array.isArray(result?.Response)
//         ? result.Response[0]
//         : result.Response;

//       if (
//         responseItem?.Status === "Success" ||
//         responseItem?.Response === "OK"
//       ) {
//         toast.success("Vehicle type submitted successfully!");
//         setTimeout(() => {
//           window.location.href = "/showvehicletype";
//         }, 1500);
//       } else {
//         toast.success("Vehicle type submitted successfully!");
//         setTimeout(() => {
//           window.location.href = "/showvehicletype";
//         }, 1000);
//       }
//     } catch (err) {
//       console.error("Network or fetch error:", err);
//       toast.error("Network or server error!");
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <form className="compney_form" ref={formRef} onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Vehicle Type</h5>

//         <div className="compney_input_div">
//           <label>Vehicle Type</label>
//           <input
//             type="text"
//             name="VTYPE"
//             value={formData.VTYPE}
//             onChange={handleChange}
//             placeholder="Enter Vehicle Type"
//             required
//           />
//         </div>

//         <button type="submit">Submit</button>
//       </form>
//     </div>
//   );
// }

// export default VehicleType;






import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";


function VehicleType() {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    VTYPE: "",
  });

  const [loading, setLoading] = useState(false);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  useEffect(() => {
    if (location.state?.responseData) {
      setFormData({
        VTYPE: location.state.responseData.VTYPE || "",
        ID: location.state.responseData.ID || "",
      });
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const formParams = new URLSearchParams();
//     formParams.append("SecurityKey", SECURITY_KEY);
//     formParams.append("TableName", "VehicleTypes");
//     formParams.append("VTYPE", formData.VTYPE);
//     if (formData.ID) {
//       formParams.append("ID", formData.ID);
//     }

//     try {
//       // const apiUrl = "https://etour.responseinfoway.com/restapi/insertdata.aspx";
//       const apiUrl = `${BASE_REST_API_URL}/insertdata.aspx`; 

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: formParams.toString(),
//       });

//       // Try reading text, but don't break if it fails
//     let textResponse = "";
//     try {
//       textResponse = await response.text();
//     } catch {
//       console.warn("Couldn't parse server response, but continuing...");
//     }

//     console.log("API Raw Response:", textResponse);

//     // Treat even network parse errors as success if we reach here
//     toast.success("Vehicle type submitted successfully!");
//     setTimeout(() => {
//       navigate("/showvehicletype");
//     }, 1500);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!formData.VTYPE || !formData.VTYPE.trim()) {
      showToast.warn("Vehicle type name is required.");
      return;
    }

    setLoading(true);

    try {
      const res = await apiWithLog({
        method: "POST",
        url: `${BASE_API_URL}/vehicletypes`,
        data: { VTYPE: formData.VTYPE.trim() },
        module: "VehicleTypeMaster",
        action: "A",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;
      console.log("Vehicle Type Create Response:", result);

      if ((res.status === 200 || res.status === 201) && (result?.status || result?.success)) {
        showToast.save("Vehicle type submitted successfully!");
        setTimeout(() => {
          navigate("/showvehicletype");
        }, 1200);
      } else {
        showToast.error(result?.message || "Failed to submit vehicle type.");
      }
    } catch (err) {
      console.error("Create vehicle type error:", err);

      showToast.error(
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Network error while submitting vehicle type."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Add Vehicle Type</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/showvehicletype">Vehicle Types</Link>
            <span>/</span>
            <span>New</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Vehicle Type Details</h5>
        </div>

        <form ref={formRef} onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            <div className="update_ledger_field">
              <label htmlFor="VTYPE">
                Vehicle Type <span className="required">*</span>
              </label>
              <input
                type="text"
                id="VTYPE"
                name="VTYPE"
                value={formData.VTYPE}
                onChange={handleChange}
                placeholder="e.g. SEDAN, SUV, INNOVA"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/showvehicletype" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Vehicle Type"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VehicleType;
